import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { trackWebVitals } from './stats';

// Boot-capture UTM: loe URL-ist sünkroonselt ENNE React-i renderdust ja salvesta
// localStorage'i. Vajalik, sest App.js navigeerimine kirjutab URL-i query-stringi
// (?utm_*) üle (pushState/replaceState). Kui püük sõltuks ainult esimese page_view
// effektist, jääks UTM kinni püüdmata, kui see fetch ebaõnnestub või effekti-järjekord
// muutub. Siin püütud, stats.js getUtm() loeb sama localStorage'i fallback'ina.
try {
  const params = new URLSearchParams(window.location.search);
  ['utm_source', 'utm_campaign', 'utm_content'].forEach((key) => {
    const val = params.get(key);
    if (val) localStorage.setItem(key, val);
  });
} catch (e) { /* URLSearchParams puudu vanas brauseris */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Mõõda tegelik laadimisaeg (LCP/FCP/TTFB) ja saada stats-tabelisse.
trackWebVitals();